import React from 'react';
import { FileText, Upload } from 'lucide-react';

interface DocumentsTabProps {
  debtorId: string;
}

export default function DocumentsTab({ debtorId }: DocumentsTabProps) {
  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-semibold">Dokumen Debitur</h3>
        <p className="text-gray-500 text-sm">
          Upload dan kelola dokumen wajib serta dokumen pendukung
        </p>
      </div>

      <div className="border-2 border-dashed border-gray-300 rounded-lg p-8 text-center">
        <FileText className="w-12 h-12 text-gray-400 mx-auto mb-4" />
        <p className="text-gray-600 mb-2">Drag & drop dokumen di sini</p>
        <p className="text-gray-400 text-sm mb-4">atau</p>
        <button
          type="button"
          className="inline-flex items-center gap-2 px-4 py-2 bg-amber-600 text-white rounded-lg hover:bg-amber-700 transition-colors"
        >
          <Upload className="w-4 h-4" />
          Pilih File
        </button>
        <p className="text-xs text-gray-400 mt-4">Format yang didukung: PDF, JPG, PNG (max 5MB)</p>
      </div>

      <div className="text-sm text-gray-500">Debtor ID: {debtorId}</div>
    </div>
  );
}
